module.exports = __webpack_public_path__ + "img/2012-12-14 20.01.04.1d38f8cc.jpg";